import APIS from "../../constant/EndPoint";
import DateRangePicker from "../Reusable/DateRangePicker";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
import { IFilterPickup } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import { getKey } from "../../helpers/sessionKey";

interface Props {
  setValue: UseFormSetValue<IFilterPickup>;
  getValues: UseFormGetValues<IFilterPickup>;
  handleFilterReset: () => void;
  control: Control<IFilterPickup, any>;
  isFilterVisible: boolean;
}
const PickupRequestFilter = ({
  setValue,
  getValues,
  isFilterVisible,
  handleFilterReset,
  control,
}: Props) => {
  return (
    <>
      {/* {clientType === "logistic" ? (
        <div
          className={classNames(
            isFilterVisible ? tw`block` : tw`hidden`,
            tw`relative`
          )}
        >
          <div className={tw`grid grid-cols-4 gap-x-4 mx-4`}>
            <DateRangePicker
              label={"Select Date Range"}
              setValue={setValue}
              name={"created__range"}
              getValues={getValues}
            />
          </div>
        </div>
      ) : 
      ( */}
      <div
        className={classNames(
          isFilterVisible ? tw`block` : tw`hidden`,
          tw`relative`
        )}
      >
        <div className={tw`grid grid-cols-4 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter<IFilterPickup>
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            name={"merchant"}
            params={{
              is_active: true,
            }}
            label={"Vendor"}
            placeholder={"Search vendor"}
            control={control}
          />
          <ComboboxFilter<IFilterPickup>
            url={APIS.VEHICLE}
            queryKey={"vehicle"}
            name={"vehicle"}
            params={{
              is_active: true,
            }}
            label={"Vehicle Number"}
            placeholder={"Search vehicle"}
            control={control}
          />

          <ComboboxFilter<IFilterPickup>
            url={APIS.DRIVER}
            queryKey={"driver"}
            name={"driver"}
            control={control}
            label={"Driver"}
            params={{
              is_active: true,
            }}
            placeholder={"Search driver"}
          />
        </div>
        <button
          className={tw`absolute -top-5 right-5`}
          onClick={handleFilterReset}
        >
          Reset
        </button>
      </div>
      {/* )} */}
    </>
  );
};

export default PickupRequestFilter;

